module.exports = __webpack_public_path__ + "static/media/JH.1f11d497.svg";